import { OrderStatus, ServiceMethod, VendorOrder } from '../types/order';
import { VenueTypes } from '../pages/home/home';

export const COLLECTION_STATUSES = [
  OrderStatus.READY_TO_COLLECT,
  OrderStatus.AT_COLLECTION_POINT,
  OrderStatus.PREPARED,
  OrderStatus.PICKED,
];

export const isCollectionOrder = (
  vendorOrders: VendorOrder[],
  venueType?: string,
  serviceMethod?: string,
): boolean => {
  if (!vendorOrders || vendorOrders.length === 0) return false;
  return vendorOrders.some(
    (vendorOrder) =>
      venueType !== VenueTypes.DINE_IN &&
      serviceMethod !== ServiceMethod.DELIVERY &&
      serviceMethod !== ServiceMethod.VENDOR_DELIVERY &&
      COLLECTION_STATUSES.includes(vendorOrder.orderStatus),
  );
};
